var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteViewIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/site green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/site-green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96219976,5.08231554 L10.3275282,11.9342024 L0.25,13.8848434 L0.25,5.08231554 L8.96219976,5.08231554 Z",
    id: "Fill-1",
    stroke: "#5f00a0",
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-5",
    points: "11.3363122 4.83231554 19.4276151 4.83231554 19.4276151 11.727754 11.3363122 11.727754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0777212,5.18231554 L19.0777212,10.1387587 L12.985399,11.3179834 L11.7629257,5.18231554 L19.0777212,5.18231554 Z",
    id: "Fill-4",
    stroke: "#5f00a0",
    strokeWidth: 0.7,
    fill: "#5f00a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-8",
    points: "2.35914895e-05 15.6146524 4.5857255 15.6146524 4.5857255 19.7220487 2.35914895e-05 19.7220487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54274008,16.0252806 L4.16469051,19.3720487 L0.350011796,19.3720487 L0.350011796,16.6432344 L3.54274008,16.0252806 Z",
    id: "Fill-7",
    stroke: "#5f00a0",
    strokeWidth: 0.7,
    fill: "#5f00a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-11",
    points: "5.91095382 12.5941515 19.4276151 12.5941515 19.4276151 19.7220841 5.91095382 19.7220841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0776977,13.0183898 L19.0776977,19.3720841 L7.04034539,19.3720841 L6.31853531,15.4879375 L19.0776977,13.0183898 Z",
    id: "Fill-10",
    stroke: "#5f00a0",
    strokeWidth: 0.7,
    fill: "#5f00a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFFFFF",
    points: "11.3363122 4.83231554 9.16731069 4.83231554 10.621726 12.1318762 1.17957448e-05 14.1878745 1.17957448e-05 16.3545169 3.82242286 15.6145698 4.5857255 19.7220841 6.74941894 19.7220841 5.91097741 15.2103297 19.4277212 12.5941515 19.4277212 10.4275091 12.7101626 11.727754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04220907,3.60430774 C2.04220907,2.63717464 2.82615426,1.85311149 3.79340533,1.85311149 C4.76042048,1.85311149 5.54448363,2.63717464 5.54448363,3.60430774 C5.54448363,4.57144085 4.76042048,5.35538604 3.79340533,5.35538604 C2.82615426,5.35538604 2.04220907,4.57144085 2.04220907,3.60430774 M7.39759511,3.60430774 C7.39759511,1.61377583 5.78393724,-3.68594044e-13 3.79340533,-3.68594044e-13 C1.80275546,-3.68594044e-13 0.189097583,1.61377583 0.189097583,3.60430774 C0.189097583,5.59483966 3.79340533,10.1877488 3.79340533,10.1877488 C3.79340533,10.1877488 7.39759511,5.59483966 7.39759511,3.60430774",
    id: "Fill-16",
    fill: "#5f00a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54453081,3.60430774 C5.54453081,2.63717464 4.76046766,1.85311149 3.79333455,1.85311149 C2.82620145,1.85311149 2.04225626,2.63717464 2.04225626,3.60430774 C2.04225626,4.57144085 2.82620145,5.35538604 3.79333455,5.35538604 C4.76046766,5.35538604 5.54453081,4.57144085 5.54453081,3.60430774",
    id: "Fill-18",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteViewIconGreen);
export default __webpack_public_path__ + "static/media/site_view_icon_green.bf86871206cbd816610c4947c9aeafa1.svg";
export { ForwardRef as ReactComponent };